import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../shared-components/ng-login/auth/auth.service';
import { CustomSnackbarService } from '../../../services/custom-snackbar.service';
import { Customer } from '../../../models/customer';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { getStorageObject } from '../../../utils/storage-manager';
import { securityDomain } from '../../main/main.component';

@Component({
  selector: 'app-user-activate-account',
  templateUrl: './user-activate-account.component.html',
  styleUrls: ['./user-activate-account.component.scss']
})
export class UserActivateAccountComponent implements OnInit {
  /**
   * Account token, used to activate the account
   */
  public token!: string;

  /**
   * Whether the token is valid or not
   */
  public validToken = true;

  /**
   * Flag to detect if the account is activated
   */
  public isActivated = false;

  protected currentCustomer: Customer | null = getStorageObject('vertical');

  protected readonly securityDomain = securityDomain;

  /**
   * Constructor
   * @param authService Authentication service
   * @param userService
   * @param translate
   * @param route Current route
   * @param snackbarService Custom toast service
   */
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    public snackbarService: CustomSnackbarService
  ) {}

  /**
   * Angular init method
   */
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.checkTranslation(params.language);
      this.token = params.token;
      this.checkToken(params.token);
    });
  }

  /**
   * Method to translate if it is necessary
   */
  checkTranslation(language: string): void {
    if (language && this.translate.currentLang !== language) {
      this.translate.use(language);
    }
  }

  /**
   * Method that checks if the provided token is valid or not
   *
   * @param token Activate account token
   */
  checkToken(token: string): void {
    this.authService.checkResetPasswordToken(token).subscribe((email) => {
      if (email) {
        this.userService.activateAccount(this.token).subscribe(() => {
          this.isActivated = true;
        });
      } else {
        this.validToken = false;
      }
    });
  }
}
